import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { 
  Monitor, 
  Clock,
  Megaphone,
  Save
} from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/axios';

const AdminHeaderPage = () => {
  const [settings, setSettings] = useState({
    showBanner: true,
    bannerText: 'Bienvenue sur votre espace client !',
    bannerLink: '',
    schedule: {
      monday: { open: '09:00', close: '18:00', enabled: true },
      tuesday: { open: '09:00', close: '18:00', enabled: true },
      wednesday: { open: '09:00', close: '18:00', enabled: true },
      thursday: { open: '09:00', close: '18:00', enabled: true },
      friday: { open: '09:00', close: '18:00', enabled: true },
      saturday: { open: '09:00', close: '12:00', enabled: false },
      sunday: { open: '', close: '', enabled: false },
    }
  });
  const [saving, setSaving] = useState(false);

  const days = [
    { key: 'monday', label: 'Lundi' },
    { key: 'tuesday', label: 'Mardi' },
    { key: 'wednesday', label: 'Mercredi' },
    { key: 'thursday', label: 'Jeudi' },
    { key: 'friday', label: 'Vendredi' },
    { key: 'saturday', label: 'Samedi' },
    { key: 'sunday', label: 'Dimanche' },
  ];

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/settings/header', settings);
      toast.success('Paramètres sauvegardés');
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Bandeau & Horaires</h1>
          <p className="text-[#64748b]">Configurez le bandeau d'information et vos horaires</p>
        </div>
        <Button onClick={handleSave} disabled={saving} className="bg-amber-600 hover:bg-amber-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Sauvegarde...' : 'Sauvegarder'}
        </Button>
      </div>

      {/* Banner Settings */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Megaphone className="w-5 h-5 text-amber-600" />
            Bandeau d'information
          </CardTitle>
          <CardDescription>Message affiché en haut de l'espace client</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-4 rounded-lg border">
            <div>
              <p className="font-medium">Afficher le bandeau</p>
              <p className="text-sm text-[#64748b]">Active/désactive le bandeau en haut de page</p>
            </div>
            <Switch 
              checked={settings.showBanner}
              onCheckedChange={(checked) => setSettings({...settings, showBanner: checked})}
            />
          </div>
          <div className="space-y-2">
            <Label>Texte du bandeau</Label>
            <Input 
              value={settings.bannerText}
              onChange={(e) => setSettings({...settings, bannerText: e.target.value})}
              placeholder="Bienvenue sur votre espace client !"
            />
          </div>
          <div className="space-y-2">
            <Label>Lien (optionnel)</Label>
            <Input 
              value={settings.bannerLink}
              onChange={(e) => setSettings({...settings, bannerLink: e.target.value})}
              placeholder="/promotions"
            />
          </div>
        </CardContent>
      </Card>

      {/* Schedule Settings */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-amber-600" />
            Horaires d'ouverture
          </CardTitle>
          <CardDescription>Horaires affichés dans le header</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {days.map((day) => (
              <div key={day.key} className="flex items-center gap-4 p-3 rounded-lg border">
                <Switch 
                  checked={settings.schedule[day.key]?.enabled}
                  onCheckedChange={(checked) => setSettings({
                    ...settings, 
                    schedule: {
                      ...settings.schedule,
                      [day.key]: { ...settings.schedule[day.key], enabled: checked }
                    }
                  })}
                />
                <span className="w-24 font-medium">{day.label}</span>
                {settings.schedule[day.key]?.enabled ? (
                  <>
                    <Input 
                      type="time"
                      value={settings.schedule[day.key]?.open || ''}
                      onChange={(e) => setSettings({
                        ...settings,
                        schedule: {
                          ...settings.schedule,
                          [day.key]: { ...settings.schedule[day.key], open: e.target.value }
                        }
                      })}
                      className="w-32"
                    />
                    <span>à</span>
                    <Input 
                      type="time"
                      value={settings.schedule[day.key]?.close || ''}
                      onChange={(e) => setSettings({
                        ...settings,
                        schedule: {
                          ...settings.schedule,
                          [day.key]: { ...settings.schedule[day.key], close: e.target.value }
                        }
                      })}
                      className="w-32"
                    />
                  </>
                ) : (
                  <span className="text-[#64748b]">Fermé</span>
                )}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminHeaderPage;
